export const getSelectedPeriod = period => {
  const source = period && period.selected ? period.selected : period;
  const yil = Number(source && source.yil);
  const chorak = Number(source && source.chorak);

  if (!yil || !chorak) {
    return null;
  }

  return {
    yil,
    chorak
  };
};

export const formatSelectedPeriod = period => {
  const selected = getSelectedPeriod(period);

  if (!selected) {
    return '';
  }

  return `${selected.yil} / ${selected.chorak}-chorak`;
};
